import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import PouleTable from "./PouleTable";
import Typography from "@material-ui/core/Typography";
import defaultFases from "../../constants/DefaultFases";
import BracketContainer from "../../containers/structure/BracketContainer";
import { withTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

class PhaseResultsDialog extends React.Component {
  getBracketElement = (bracket) => {
    const division = this.props.divisionsObject[this.props.selectedDivision];
    return (
      <div key={bracket.id}>
        <BracketContainer
          tournament={this.props.tournament}
          divisionsObject={this.props.divisionsObject}
          division={division}
          bracket={bracket}
          handleClickPouleSpot={this.handleClickPouleSpot}
          resultSpotsAll={this.props.resultSpotsAll}
          fase={this.props.fase}
          faseStarted={this.props.faseStarted}
          poules={this.props.poules
            .filter((poule) => poule.bracket === bracket.id)
            .sort((a, b) => a.num - b.num)}
          poulesByKey={this.props.poulesByKey}
          toggleResultSpotType={this.toggleResultSpotType}
          allPoules={this.props.poules}
          allBrackets={this.props.brackets}
          bracketsByKey={this.props.bracketsByKey}
          subBrackets={(this.props.subBrackets[bracket.id] || [])
            .sort((a, b) => a.num - b.num)
            .map((bracket) => this.getBracketElement(bracket))}
          subBracketsArray={this.props.subBrackets[bracket.id] || []}
          tournamentStatus={this.props.tournamentStatus}
          toggleFinishedDialog={this.props.toggleFinishedDialog}
          resultsPage={true}
        />
      </div>
    );
  };

  render() {
    let elements = [],
      i = 0,
      j = 0;

    let poules = this.props.poules
      .filter(
        (poule) =>
          poule.bracket === null &&
          poule.fase === Number(this.props.selectedPhase) &&
          poule.division === this.props.selectedDivision
      )
      .sort((a, b) => {
        if (a.indexNum > b.indexNum) {
          return 1;
        } else if (a.indexNum < b.indexNum) {
          return -1;
        } else {
          return a.num - b.num;
        }
      });
    let brackets = this.props.brackets
      .filter(
        (b) =>
          b.fase === Number(this.props.selectedPhase) &&
          b.division === this.props.selectedDivision &&
          b.subBracketTo === undefined
      )
      .sort((a, b) => {
        if (a.indexNum > b.indexNum) {
          return 1;
        } else if (a.indexNum < b.indexNum) {
          return -1;
        } else {
          return a.num - b.num;
        }
      });

    while (i < poules.length && j < brackets.length) {
      if (
        (poules[i].indexNum !== undefined
          ? poules[i].indexNum
          : poules[i].num) <=
        (brackets[j].indexNum !== undefined
          ? brackets[j].indexNum
          : brackets[j].num)
      ) {
        const poule = poules[i];
        const pouleElement = (
          <Paper
            style={{
              display: "inline-block",
              width: 650,
              margin: "0 24px 15px 24px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                background: this.props.theme.palette.primary.main,
                display: "flex",
                alignItems: "center",
                height: 30,
                paddingLeft: 10,
              }}
            >
              <Typography
                variant="body2"
                style={{ color: "white", fontWeight: 500 }}
              >
                {poule.name}
              </Typography>
            </div>
            <PouleTable
              tournament={this.props.tournament}
              selectedPoule={poule.id}
              poulesByKey={this.props.poulesByKey}
              matches={this.props.matches}
              teams={this.props.teams}
            />
          </Paper>
        );
        elements.push(pouleElement);
        i++;
      } else {
        const bracket = brackets[j];

        const bracketElement = this.getBracketElement(bracket);
        elements.push(bracketElement);
        j++;
      }
    }
    const structureElements = elements
      .concat(
        poules.slice(i).map((poule) => (
          <Paper
            style={{
              display: "inline-block",
              width: 650,
              margin: "0 24px 15px 24px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                background: this.props.theme.palette.primary.main,
                display: "flex",
                alignItems: "center",
                height: 30,
                paddingLeft: 10,
              }}
            >
              <Typography
                variant="body2"
                style={{ color: "white", fontWeight: 500 }}
              >
                {poule.name}
              </Typography>
            </div>
            <PouleTable
              tournament={this.props.tournament}
              selectedPoule={poule.id}
              poulesByKey={this.props.poulesByKey}
              matches={this.props.matches}
              teams={this.props.teams}
            />
          </Paper>
        ))
      )
      .concat(
        brackets.slice(j).map((bracket) => this.getBracketElement(bracket))
      );
    return (
      <Dialog
        open={this.props.selectedPhase !== null}
        onClose={() => {
          this.props.selectPhase(null, null);
        }}
        aria-labelledby="form-dialog-title"
        maxWidth={"lg"}
      >
        <DialogTitle id="form-dialog-title">
          {(
            ((this.props.divisionsObject[this.props.selectedDivision] || {})
              .fases || defaultFases)[this.props.selectedPhase] || {}
          ).name +
            (Object.keys(this.props.divisionsObject).length > 1
              ? " - " +
                ((this.props.divisionsObject[this.props.selectedDivision] || {})
                  .name || "")
              : "")}
        </DialogTitle>

        <DialogContent style={{ padding: 0 }}>
          {structureElements.map((s, i) => (
            <div key={i}>{s}</div>
          ))}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              this.props.selectPhase(null, null);
            }}
            variant="contained"
            color="primary"
            type="submit"
          >
            {languages.export.close}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withTheme(PhaseResultsDialog);
